// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.multiplex.RentalManagerUserPropertyMultiplexWebApiHandler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import {
  RentalManagerUserPropertyMultiplexWebApiHandler_create,
  RentalManagerUserPropertyMultiplexWebApiHandler_getUnitNumbers,
  RentalManagerUserPropertyMultiplexWebApiHandler_getUnitNumbers_Path,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  UserPropertyMultiplexCreateUnitsRequestWebDto,
  UserPropertyMultiplexCreateUnitsResponseWebDto,
  UserPropertyMultiplexGetUnitNumbersResponseWebDto,
} from '@zg-rentals/ts-rental-manager-api-client';

interface GetUnitNumbersParams {
  fullAddress: string;
}

export interface RentalManagerUserPropertyMultiplexWebApiHandler_create_Args {
  postData: UserPropertyMultiplexCreateUnitsRequestWebDto;
}

export type RentalManagerUserPropertyMultiplexWebApiHandler_create_Options = UseMutationOptions<
  UserPropertyMultiplexCreateUnitsResponseWebDto,
  unknown,
  RentalManagerUserPropertyMultiplexWebApiHandler_create_Args
>;

/**
 * Create units for a multiplex
 */
export const useRentalManagerUserPropertyMultiplexWebApiHandler_create = (
  options: Omit<RentalManagerUserPropertyMultiplexWebApiHandler_create_Options, 'mutationFn'> = {},
) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyMultiplexWebApiHandler_create_Args) =>
      RentalManagerUserPropertyMultiplexWebApiHandler_create(args.postData),
  });
};

export type RentalManagerUserPropertyMultiplexWebApiHandler_getUnitNumbers_Options = UseQueryOptions<
  UserPropertyMultiplexGetUnitNumbersResponseWebDto,
  unknown,
  UserPropertyMultiplexGetUnitNumbersResponseWebDto,
  readonly [string, GetUnitNumbersParams]
>;

const RentalManagerUserPropertyMultiplexWebApiHandler_getUnitNumbers_GetKey = (getParams: GetUnitNumbersParams) =>
  [RentalManagerUserPropertyMultiplexWebApiHandler_getUnitNumbers_Path, getParams] as const;

export const RentalManagerUserPropertyMultiplexWebApiHandler_getUnitNumbers_queryOptions = (
  getParams: GetUnitNumbersParams,
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPropertyMultiplexWebApiHandler_getUnitNumbers_GetKey(getParams),
    queryFn: () => RentalManagerUserPropertyMultiplexWebApiHandler_getUnitNumbers(getParams),
  }) as const satisfies QueryOptions;

/**
 * Get unit numbers for a multiplex
 */
export const useRentalManagerUserPropertyMultiplexWebApiHandler_getUnitNumbers = (
  getParams: GetUnitNumbersParams,
  options: Omit<RentalManagerUserPropertyMultiplexWebApiHandler_getUnitNumbers_Options, 'queryFn' | 'queryKey'> = {},
) => {
  return useQuery({
    ...RentalManagerUserPropertyMultiplexWebApiHandler_getUnitNumbers_queryOptions(getParams),
    ...options,
  });
};
useRentalManagerUserPropertyMultiplexWebApiHandler_getUnitNumbers.getKey =
  RentalManagerUserPropertyMultiplexWebApiHandler_getUnitNumbers_GetKey;
